<app-dialog-header [title]="title|trans" color="primary" noClose="true" />

<div mat-dialog-content [innerHTML]="message|safe"></div>

<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close] color="warn">{{ cancelText|trans }}</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">{{ confirmText|trans }}</button>
</div>